import { ComponentRef } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { ModalCloseData } from './modal.interface';

export class ModalRef<T> {
    private readonly _afterClosed = new Subject<any>();
    afterClosed: Observable<any> = this._afterClosed.asObservable();
    private _componentRef: ComponentRef<any>;

    close(data: ModalCloseData = {}) {
        this._afterClosed.next(data);
    }

    get componentInstance(): T {
        if (this._componentRef) {
            return this._componentRef.instance;
        }
    }

    setComponentRef(componentRef: ComponentRef<T>) {
        this._componentRef = componentRef;
    }

    get modalInstance(): ModalRef<T> {
        return this;
    }
}
